export default {
  css: {
    general: 'body',
    links: 'a',
    announcement: '.announcement',
    announcementSpan: '.announcement span',
    navbar: 'header',
    logo: 'header .logo',
    search: '.search',
    menu: '#sidebar',
    image: 'img',
    footer: 'footer.container',
    productCollection: '.product-collection',
    productVendor: '.product-vendor',
    productType: '.product-type',
    productTitle: '.product-title',
    productReview: '.review-title',
    productReviewStar: '.stars',
    productReviewText: '.stars + span',
    productReviewsHeading: '.reviews-title',
    productReviewAuthor: '.reviews .author',
    productReviewAuthorInitials: '.reviews .initials',
    productReviewDate: '.reviews .date',
    productReviewBody: '.reviews .body',
    productReviewReply: '.reviews .reply',
    productInventoryStatus: '.availability.h4',
    productInStock: '.availability.h4 > .in-stock',
    productOutOfStock: '.availability.h4 > .out-of-stock',
    productWillBeBackBy: '.availability.h4 > .incoming-date',
    variantSelector: '.variant-selector label',
    quantitySelector: '.product-quantity-selector',
    quantitySelectorLeftButton: '.product-quantity-selector > .input-group-prepend > .btn',
    quantitySelectorRightButton: '.product-quantity-selector > .input-group-append > .btn',
    addToCartButton: '.btn-add-to-cart',
    addToCartButtons: '.product-cart-buttons',
    quickBuyButton: '.btn-quick-buy',
    productPriceBar: '.price',
    productSalePrice: '.price .original-price',
    productCompareAtPrice: '.price .compare-at-price',
    productSavings: '.product-save',
    productPageLink: '.full-link',
    productRelatedProductsHeading: '.related-products-title',
    productGridText: '.product-grid a',
    productGridProductTitle: '.product-grid .product-grid-product-title',
    productGridProductType: '.product-grid .product-grid-product-type',
    productGridReview: '.product-grid .review-mini',
    productGridProductPrice: '.product-grid .product-grid-product-price',
    productGridSavings: '.product-grid .product-save',
    productGridSoldOut: '.product-grid .product-unavailable span',
    collectionTitle: '.collection-title',
    filterButton: '.btn-filter',
    postTitle: '.article-title',
    postAuthor: '.article-author',
    postDate: '.article-date',
    postRecentPostsHeading: '.recent-articles-title',
    postRecentPostsTitle: '.recent-articles p',
    postRecentPostsDate: '.recent-articles time',
    buttonReviewSeeReviews: '.btn-see-reviews',
    buttonSeeRecommendations: '.btn-see-recommendations',
    collectionDescription: '.collection-description'
  },
  html: {
    announcement_text: '.announcement span',
    logo_text: 'header .logo span',
    logo_asset_version: 'header .logo-image amp-img, header .logo-image img',
    search_placeholder: '.search > input',
    footer_text: 'footer > p:first-of-type span',
    view_full_page_text: 'footer > p:first-of-type a',
    collection_in_text: '.product-collection span',
    vendor_in_text: '.product-vendor span',
    single_review_text: '.review-title > span:nth-child(2) > span:nth-child(2)',
    multiple_review_text: '.review-title > span:nth-child(2) > span:nth-child(2)',
    in_stock_text: '.availability.h4 > .in-stock',
    out_of_stock_text: '.availability.h4 > .out-of-stock',
    will_be_back_by_text: '.availability.h4 > span > .will-be-back-by',
    will_not_ship_until_text: '.availability.h4 > span > .will-not-ship-until',
    add_to_cart_text: '.btn-add-to-cart > span:nth-child(2)',
    quick_buy_text: '.btn-quick-buy > span:nth-child(2)',
    save_text: '.product-save span:first-child',
    product_page_link_text: '.full-link:not(.all-reviews) a',
    reviews_title_text: '.reviews-title',
    related_products_title_text: '.related-products-title',
    product_grid_products_sold_out_text: '.product-grid .product-unavailable span',
    filter_button_text: '.btn-filter > span:nth-child(2)',
    consent_text: '#cookie-privacy-consent-ui .consent-text > p:first-child',
    consent_link_text: '#cookie-privacy-consent-ui a',
    consent_ok_text: '#cookie-privacy-consent-ui button',
    recent_articles_title_text: '.recent-articles-title',
    review_see_reviews_text: '.btn-see-reviews',
    see_recommendations_text: '.btn-see-recommendations'
  }
}
